export enum PaymentMethodsEnum {
  Billet = 'boleto',
  Credit_card = 'cartao-credito',
  Pix = 'pix',
}
